import * as React from 'react';
import { Body1 } from '@cian/ui-kit';
import * as styles from './BubbleContent.css';
import { BubbleContentList } from '../BubbleContentList';
import { TBubbleBody } from '../../types/messageBubble';

interface IProps {
  content: TBubbleBody[];
}

export const BubbleContent = (props: IProps) => {
  const { content } = props;

  return (
    <div className={styles['content']} data-name="BubbleMessage_content">
      {content.map((block, index) => {
        const { type, data } = block;

        if (type === 'list') {
          return <BubbleContentList key={index} data={data} />;
        }

        if (type === 'text') {
          return <Body1 key={index}>{data}</Body1>;
        }

        return null;
      })}
    </div>
  );
};
